export default __webpack_public_path__ + "static/logo_black_new-8bc8332c5cf5273a62205dc1d306e73b.mp4";